// extracted by mini-css-extract-plugin
module.exports = {"AuthScreen":"styles_AuthScreen__3hpEJ","AuthFormWrapper":"styles_AuthFormWrapper__2P33_"};